export default __webpack_public_path__ + "static/media/net-overlay.2a3aba8e.png";